<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="matricula-reprovacao-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span>

                        <div class="row g-4">
                            <div class="col-12 col-md-8 col-lg-4">
                                <label for="pesquisaReprovacaoMatricula" class="form-label">Pesquisar</label>
                                <input id="pesquisaReprovacaoMatricula" v-model="search" @keyup="apertouEnter"
                                    type="text" class="form-control form-control-solid"
                                    placeholder="Disciplina ou tipo" />
                            </div>

                            <div class="col-12 col-md-4 col-lg-8 panel-actions">
                                <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                                    Limpar filtros
                                </button>
                            </div>
                        </div>
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false">
                            <th>Disciplina</th>
                            <th>Tipo</th>
                            <th>Media</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
const authStore = namespace("auth");
import CardRh from "@/components/cards/ManzaCard.vue";
import MatriculaService from "@/service/v1/sigap/MatriculaService";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { Prop } from "vue-property-decorator";

@Options({
    name: "ReprovacaoMatriculaIndex",
    components: { CardRh, KDataTable },
})
export default class ReprovacaoMatriculaIndex extends Vue {
    @Prop() readonly matricula!: any;

    @authStore.Getter
    public perfis!: any;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public matriculaId: any = null;
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.refreshTable();
    }

    created() {
        this.matriculaId = this.$route.params.id;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new MatriculaService();
        this.config.ajax = {
            url: this.service.getApiUrl() + "/" + this.matriculaId + "/Dependencia",
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.columns = [
            { data: "descricao", name: "descricao" , orderable: false},
            { data: "tipo", name: "tipo" , orderable: false},
            { data: "mediaAluno", name: "mediaaluno" , orderable: false},
        ];

        this.config.columnDefs = [
            {
                targets: 1,
                render: (row) => {
                    return row.nome.replaceAll("_", " ");
                }
            },
        ];
    }
}
</script>

<style scoped>
.matricula-reprovacao-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
